import { JSXElement, mergeProps } from 'solid-js';
import Request from '~/api/Request.ts';
import {
  PublicPagePath,
  getSlug,
  shouldIgnoreUnauthorizedLoginRedirection
} from '~/components/AppRouter/utils.ts';
import { AppErrors } from '~/components/ErrorBoundaries/utils.ts';
import logger from '~/utils/logger';

type WorkspaceApiConnectorProps = {
  children: JSXElement;
};

export function WorkspaceApiConnector(
  props: WorkspaceApiConnectorProps
): JSXElement {
  const merged = mergeProps({}, props);

  new Request({
    onResponseError: (error) => {
      logger.info(`Axios response interceptor`);
      // Handle unauthorized responses and send to /login
      let responseData;
      try {
        responseData = JSON.parse(error.response.data);
      } catch (_) {}
      if (
        error.response &&
        error.response.status === 401 &&
        !(
          shouldIgnoreUnauthorizedLoginRedirection() ||
          responseData.details?.[0]?.error_code === AppErrors.TOOL_ERROR
        )
      ) {
        logger.info(`Axios response interceptor :: Redirecting to login page`);
        const urlParams = new URLSearchParams({
          redirectTo: location.pathname
        });
        window.location.assign(
          `${getSlug.publicPage(PublicPagePath.LOGIN, true)}?${urlParams.toString()}`
        );
        throw new Error(AppErrors.REDIRECT_ON_WORKSPACE_SESSION_EXPIRY);
      }
      // for all other errors, propagate as usual
      return Promise.reject(error);
    }
  });
  return <>{merged.children}</>;
}
